import React from "react";
import { Stack } from "@mui/material";
import ProductRow from "./ProductRow";

export default function ProductList({ products, onQuickView, isMobile = false }) {
  return (
    <Stack spacing={{ xs: 1.5, sm: 2 }}>
      {products.map(p => (
        <ProductRow 
          key={p.id} 
          product={p} 
          onQuickView={onQuickView} 
          isMobile={isMobile} 
        />
      ))}
    </Stack>
  );
}